// Chinese translations of the Italian back-office strings (keys = Italian source text; see lib/i18n.ts).
const dict: Record<string, string> = {
  "— nessuna (categoria principale) —": "— 无（一级分类）—",
  "— seleziona —": "— 请选择 —",
  "… e altre {n} righe.": "… 还有 {n} 行。",
  "({n} non in questa vista)": "（{n} 条不在当前视图中）",
  "(es. stesse candele in fragranze diverse)": "（例如：同款蜡烛的不同香型）",
  "(fino a 4, sotto il prezzo)": "（最多 4 个，显示在价格下方）",
  "(modificato)": "（已修改）",
  "(si apre in una nuova scheda)": "（在新标签页中打开）",
  "{amount} di sconto": "优惠 {amount}",
  "{day}: {amount} · {n} ordini": "{day}：{amount} · {n} 个订单",
  "{kg} kg · serve per calcolare la spedizione": "{kg} kg · 用于计算运费",
  "{n} aggiornati": "已更新 {n} 项",
  "{n} clienti registrati": "{n} 位注册客户",
  "{n} da preparare": "{n} 个待备货",
  "{n} errori": "{n} 个错误",
  "{n} foto": "{n} 张图片",
  "{n} giacenza modificata, non ancora salvate": "{n} 项库存已修改，尚未保存",
  "{n} giacenze aggiornate.": "已更新 {n} 项库存。",
  "{n} giacenze incluse": "含 {n} 项库存",
  "{n} giacenze modificate, non ancora salvate": "{n} 项库存已修改，尚未保存",
  "{n} giorni": "{n} 天",
  "{n} nuovi": "新增 {n} 个",
  "{n} operazioni registrate": "共 {n} 条操作记录",
  "{n} ordini": "{n} 个订单",
  "{n} ordini da preparare": "{n} 个订单待备货",
  "{n} pezzi": "{n} 件",
  "{n} prodotti": "{n} 个商品",
  "{n} punti di forza": "{n} 个卖点",
  "{n} punto di forza": "{n} 个卖点",
  "{n} pz": "{n} 件",
  "{n} righe con errori (saranno ignorate)": "{n} 行有错误（将被忽略）",
  "{n} righe valide": "{n} 行有效",
  "{n} selezionati": "已选 {n} 项",
  "{n} su 5": "{n}/5 分",
  "{n} utilizzi": "已使用 {n} 次",
  "{n}/200 caratteri": "{n}/200 字",
  "{n}% di sconto": "{n}% 折扣",
  "{name} è ora membro del Club.": "{name} 已成为会员。",
  "{name} non è più membro del Club.": "{name} 已不再是会员。",
  "{name}: preparato": "{name}：已备货",
  "{p}% dei clienti registrati": "占注册客户的 {p}%",
  "+ Invita persona": "+ 邀请成员",
  "+ Nuova categoria": "+ 新建分类",
  "+ Nuova regola": "+ 新建规则",
  "+ Nuovo codice": "+ 新建优惠码",
  "+ Nuovo negozio": "+ 新建门店",
  "+ Nuovo punto": "+ 新建自提点",
  "1. Verifica (nessuna modifica)": "1. 校验（不做任何修改）",
  "2. Importa": "2. 导入",
  "Accedi": "登录",
  "Accessi alla gestione online": "线上管理权限",
  "Accesso attivo": "已开通访问",
  "Accesso non autorizzato": "未授权访问",
  "Aggiorna": "刷新",
  "Aggiorna dati": "刷新数据",
  "Aggiornamento automatico ogni 30 secondi": "每 30 秒自动刷新",
  "Aggiornamento…": "刷新中…",
  "Aggiungi al Club": "加入会员",
  "Aggiungi nota": "添加备注",
  "Aggiungi punto di forza": "添加卖点",
  "Al": "至",
  "Al giorno": "结束日期",
  "al netto dei rimborsi": "已扣除退款",
  "Alcuni negozi non hanno ancora indirizzo e orari: completali prima del lancio.": "部分门店尚未填写地址和营业时间，请在上线前补全。",
  "aliquota IVA non valida (0, 4, 5, 10, 22)": "增值税税率无效（0、4、5、10、22）",
  "Almeno 10 caratteri": "至少 10 个字符",
  "Altre azioni per {n}": "{n} 的更多操作",
  "Altre impostazioni": "其他设置",
  "Altro": "更多",
  "Amministratore": "管理员",
  "Amministratore — tutto, inclusi negozi e personale": "管理员 — 全部权限，包括门店和员工",
  "Analisi dati": "数据分析",
  "Ancora nessuna operazione registrata.": "暂无操作记录。",
  "Andamento {metric}: periodo attuale {current}, periodo precedente {previous}": "{metric}趋势：本期 {current}，上期 {previous}",
  "Andamento vendite": "销售趋势",
  "Annulla": "取消",
  "Annulla e rimborsa": "取消并退款",
  "Annulla e rimborsa {amount}": "取消并退款 {amount}",
  "Annulla l'ordine {number}": "取消订单 {number}",
  "Annulla modifiche": "撤销修改",
  "Annulla ordine": "取消订单",
  "Annulla ordine…": "取消订单…",
  "Annullati": "已取消",
  "Annullato": "已取消",
  "Anteprima": "预览",
  "Applica": "应用",
  "Apri menu": "打开菜单",
  "Apri ordine": "打开订单",
  "Area riservata al personale.": "员工专区。",
  "Attiva": "启用",
  "Attivo": "已启用",
  "Avviso scorte": "库存预警",
  "Azione": "操作",
  "Azioni": "操作",
  "Azzera filtri": "清除筛选",
  "Buon pomeriggio": "下午好",
  "Buonasera": "晚上好",
  "Buongiorno": "早上好",
  "C.F.": "税号",
  "Cambia foto": "更换图片",
  "Cambia password": "修改密码",
  "Cambio di stato non consentito.": "不允许变更为该状态。",
  "Canali di vendita": "销售渠道",
  "Carica foto": "上传图片",
  "Carica immagini": "上传图片",
  "Caricamento…": "加载中…",
  "Casa (per ogni ambiente)": "家（适用于各个空间）",
  "CASA & TE Club: iscrizione gratuita, offerte riservate ai membri.": "CASA & TE Club：免费加入，享会员专属优惠。",
  "Catalogo": "商品目录",
  "Categoria": "分类",
  "Categoria padre": "上级分类",
  "Categoria superiore": "上级分类",
  "Categorie": "分类",
  "Causale": "原因",
  "Cerca": "搜索",
  "Cerca nome, marca, SKU, EAN": "搜索名称、品牌、SKU、EAN",
  "Cerca nome, SKU, EAN (anche con lettore barcode)": "搜索名称、SKU、EAN（支持扫码枪）",
  "Cerca ordini": "搜索订单",
  "Cerca ordini, prodotti, clienti…": "搜索订单、商品、客户…",
  "Cerca ordini, prodotti…": "搜索订单、商品…",
  "Cerca prodotto": "搜索商品",
  "Chi ha modificato cosa, e quando.": "谁在何时修改了什么。",
  "Chiudi menu": "关闭菜单",
  "Chiudi messaggio": "关闭消息",
  "Chiudi senza salvare": "不保存并关闭",
  "Ci sono {n} ordini": "共有 {n} 个订单",
  "Ci sono modifiche non salvate. Uscire senza salvare?": "有未保存的修改，确定不保存就离开吗？",
  "Città": "城市",
  "Cliente": "客户",
  "Cliente (Club)": "客户（会员）",
  "Clienti": "客户",
  "Clienti degli ultimi 7 giorni": "近 7 天客户",
  "Clienti di oggi": "今日客户",
  "Codice": "编码",
  "Codice (es. LU1)": "编码（例如 LU1）",
  "Codice a barre": "条形码",
  "Codice di tracciamento": "物流单号",
  "Codice già esistente.": "编码已存在。",
  "Codice sconto": "优惠码",
  "Codice, nome e città sono obbligatori.": "编码、名称和城市为必填项。",
  "Codice: 3–32 caratteri tra lettere, numeri, - e _.": "编码：3–32 个字符，可包含字母、数字、- 和 _。",
  "Codici sconto": "优惠码",
  "Colore": "颜色",
  "Colore / materiale": "颜色 / 材质",
  "colore e varianti: massimo 40 caratteri": "颜色和规格：最多 40 个字符",
  "Compila i campi con * e crea il prodotto.": "填写带 * 的字段即可创建商品。",
  "Compila il foglio {sheet} del modello (le istruzioni sono nel foglio {help}) e caricalo qui così com'è, in formato .xlsx.": "请填写模板中的 {sheet} 工作表（填写说明见 {help} 工作表），然后直接以 .xlsx 格式上传。",
  "Compila nome, indirizzo, città, CAP (5 cifre) e provincia (2 lettere).": "请填写名称、地址、城市、邮编（5 位）和省份（2 个字母）。",
  "Completati": "已完成",
  "Completato": "已完成",
  "Con la spunta «Mostra in home» scegli le 8 categorie principali mostrate nella home del negozio.": "勾选「首页展示」，选择在商店首页展示的 8 个主要分类。",
  "Conferma password": "确认密码",
  "Conferma rimozione": "确认移除",
  "Conferma spedizione": "确认发货",
  "confezione non valida (es. 500 ml, 1,5 l, 250 g, 6 pz)": "包装规格无效（例如 500 ml、1,5 l、250 g、6 pz）",
  "Configurazione mancante": "缺少配置",
  "Consegna": "配送",
  "Consegna a domicilio": "送货上门",
  "Consegnato al cliente": "已交付客户",
  "Consegnato al cliente (ritirato)": "已交付客户（已自提）",
  "Contenuto confezione": "包装内容",
  "Copia apps/admin/.env.example in apps/admin/.env con URL e chiave anon di Supabase.": "将 apps/admin/.env.example 复制为 apps/admin/.env，并填入 Supabase 的 URL 和 anon 密钥。",
  "Copia numero ordine": "复制订单号",
  "Copiato": "已复制",
  "Corriere": "快递公司",
  "Crea o aggiorna prodotti, prezzi, schede e giacenze in blocco da Excel o CSV (chiave: SKU)": "通过 Excel 或 CSV 批量创建或更新商品、价格、详情和库存（以 SKU 为键）",
  "Crea prodotto": "创建商品",
  "Creato": "已创建",
  "Credenziali non valide.": "账号或密码错误。",
  "Cronologia": "历史记录",
  "Cuore (preferito)": "心形（喜爱）",
  "da {n} giorni": "{n} 天前",
  "da {n} giorno": "{n} 天前",
  "da {n} h": "{n} 小时前",
  "da {n} min": "{n} 分钟前",
  "Da completare": "待完善",
  "Da pagare": "待付款",
  "Da preparare": "待备货",
  "Dal": "从",
  "Dal giorno": "开始日期",
  "Data": "日期",
  "Data e ora": "日期时间",
  "Data ordine": "下单日期",
  "Dati fattura": "发票信息",
  "Descrizione": "描述",
  "Descrizione del Club": "会员俱乐部简介",
  "Descrizione mostrata ai clienti": "向客户展示的描述",
  "Dettaglio completo": "完整详情",
  "di cui {n} da iniziare": "其中 {n} 个尚未开始",
  "Diamante (design, qualità)": "钻石（设计、品质）",
  "Disattiva": "停用",
  "Disattivato": "已停用",
  "Disattivo": "未启用",
  "Disponibili": "可用库存",
  "Domicilio": "送货上门",
  "Dopo la creazione potrai aggiungere immagini e giacenze.": "创建后即可添加图片和库存。",
  "EAN / codice a barre": "EAN / 条形码",
  "EAN non valido": "EAN 无效",
  "Elemento": "对象",
  "Elemento non trovato.": "未找到该项。",
  "Elemento o utente": "对象或用户",
  "Elenco": "列表",
  "Elimina": "删除",
  "Elimina immagine": "删除图片",
  "Eliminare definitivamente la recensione di {name}? Il cliente potrà scriverne una nuova.": "确定永久删除 {name} 的评价吗？该客户可以重新撰写评价。",
  "Eliminare la categoria \"{name}\"? I prodotti resteranno senza categoria.": "确定删除分类「{name}」吗？其下商品将变为未分类。",
  "Eliminare questa immagine dal prodotto?": "确定从商品中删除这张图片吗？",
  "Eliminato": "已删除",
  "Email": "邮箱",
  "Email non valida.": "邮箱格式无效。",
  "Email, nome, telefono": "邮箱、姓名、电话",
  "emessi su Stripe": "已通过 Stripe 发放",
  "English": "English",
  "Errore": "错误",
  "es. Beige": "例如：米色",
  "es. BRT, GLS, Poste": "例如：BRT、GLS、Poste",
  "es. diffusore-tessuto": "例如：diffusore-tessuto",
  "es. Fatto in Italia": "例如：意大利制造",
  "es. fragranza": "例如：香型",
  "es. InPost, BRT Fermopoint": "例如：InPost、BRT Fermopoint",
  "es. prodotto mancante": "例如：商品缺货",
  "es. Tessuto": "例如：布艺",
  "Esaurito": "已售罄",
  "Esci": "退出登录",
  "Esegui prima la verifica: l'importazione si abilita quando non ci sono errori.": "请先执行校验：没有错误时才能导入。",
  "Esporta consensi marketing": "导出营销授权客户",
  "Esporta CSV": "导出 CSV",
  "Esporta membri (CSV)": "导出会员（CSV）",
  "Esportazione…": "导出中…",
  "Etichetta": "标签",
  "Fattura richiesta": "需要发票",
  "Fatturato": "销售额",
  "Filtra per stato": "按状态筛选",
  "Filtro": "筛选",
  "Fine": "结束",
  "fino al {date}": "截至 {date}",
  "Foglia (naturale)": "叶子（天然）",
  "Formati accettati: JPG, PNG, WEBP.": "支持格式：JPG、PNG、WEBP。",
  "Foto di copertina (cerchio in home)": "封面图（首页圆圈）",
  "generato dal nome": "根据名称自动生成",
  "Gestione categorie": "分类管理",
  "Gestione inventario": "库存管理",
  "Gestione negozi": "门店管理",
  "Gestione ordini": "订单管理",
  "Gestione prodotti": "商品管理",
  "Gestione staff": "员工管理",
  "Gestisci in Marketing": "前往营销管理",
  "Giacenza {name}": "{name} 库存",
  "Giacenza {store}": "{store} 库存",
  "giacenza {store} non valida": "{store} 库存无效",
  "Giacenza non valida: usa un numero intero da 0 in su.": "库存无效：请输入 0 或以上的整数。",
  "Giacenze": "库存",
  "Giacenze per negozio": "各门店库存",
  "Giacenze vendibili online per negozio. Gli ordini online le scalano automaticamente.": "各门店可在线销售的库存。线上订单会自动扣减。",
  "Goccia (liquidi, fragranze)": "水滴（液体、香氛）",
  "Gruppo varianti": "规格组",
  "Hai {n} modifica non salvata. Vuoi scartarle?": "你有 {n} 项未保存的修改，确定放弃吗？",
  "Hai {n} modifiche non salvate. Vuoi scartarle?": "你有 {n} 项未保存的修改，确定放弃吗？",
  "Home": "首页",
  "I nuovi ordini pagati compaiono qui da soli. Puoi lasciare questa pagina aperta.": "新的已付款订单会自动显示在这里，可保持此页面打开。",
  "Icona {n}": "图标 {n}",
  "Ieri": "昨天",
  "ieri {value}": "昨日 {value}",
  "il cliente": "该客户",
  "Il cliente vedrà: {label} · {pack}": "客户将看到：{label} · {pack}",
  "Il Club al momento non accetta nuove iscrizioni.": "会员俱乐部目前暂停接受新会员。",
  "Il mio account": "我的账号",
  "Il peso in grammi è obbligatorio (serve per la spedizione).": "克重为必填项（用于计算运费）。",
  "Il prezzo barrato deve essere maggiore del prezzo.": "划线价必须高于售价。",
  "Il rimborso viene inviato subito tramite Stripe e non si può annullare.": "退款将立即通过 Stripe 发出，且无法撤销。",
  "Il tuo account non è abilitato alla gestione. Contatta un amministratore.": "你的账号未开通管理权限，请联系管理员。",
  "Immagine troppo grande (max 5 MB).": "图片过大（最大 5 MB）。",
  "Immagini": "图片",
  "Import CSV": "CSV 导入",
  "Importa da Excel": "从 Excel 导入",
  "Importa prodotti": "导入商品",
  "Importazione {i}/{n}…": "导入中 {i}/{n}…",
  "Importazione completata": "导入完成",
  "Importi rapidi": "快捷金额",
  "Importo": "金额",
  "Importo (€)": "金额（€）",
  "Importo da rimborsare (residuo {amount})": "退款金额（剩余 {amount}）",
  "Importo del rimborso non valido.": "退款金额无效。",
  "Importo fisso": "固定金额",
  "Importo non valido.": "金额无效。",
  "Impossibile leggere il file Excel. Salvalo come .xlsx oppure come CSV e riprova.": "无法读取 Excel 文件，请另存为 .xlsx 或 CSV 后重试。",
  "Imposta la password": "设置密码",
  "Impostazioni": "设置",
  "Impostazioni del Club": "会员俱乐部设置",
  "Impostazioni del Club salvate.": "会员俱乐部设置已保存。",
  "Impostazioni del negozio": "商店设置",
  "Impostazioni di sistema": "系统设置",
  "In attesa di pagamento": "待付款",
  "In evidenza": "精选",
  "In evidenza nella home": "首页精选",
  "In home": "首页",
  "In preparazione": "备货中",
  "Incassi, consegne e prodotti più venduti nel periodo scelto.": "所选时段内的收入、配送和畅销商品。",
  "Incasso netto": "净收入",
  "Incasso per giorno": "每日收入",
  "Incasso per giorno: {list}.": "每日收入：{list}。",
  "indica anche la categoria della sottocategoria": "请同时填写子分类所属的上级分类",
  "Indica il nome della variante (es. \"Tessuto\") per questo prodotto.": "请为该商品填写规格名称（例如「布艺」）。",
  "indica il nome della variante (es. Tessuto)": "请填写规格名称（例如：布艺）",
  "Indirizzi e orari vengono mostrati ai clienti per il ritiro": "地址和营业时间将展示给自提客户",
  "Indirizzi, orari e ritiro in negozio": "地址、营业时间与门店自提",
  "Indirizzo": "地址",
  "Indirizzo pagina (slug)": "页面地址（slug）",
  "Inizia preparazione": "开始备货",
  "Inizio": "开始",
  "Inserisci l'email.": "请输入邮箱。",
  "Inserisci solo punti reali concordati con il corriere. I punti \"DEMO\" del database di prova vanno disattivati prima del lancio.": "只能添加与快递公司实际签约的自提点。测试数据库中的「DEMO」自提点须在上线前停用。",
  "Inserisci un importo tra €0,01 e {max}.": "请输入 €0,01 至 {max} 之间的金额。",
  "Inserisci un numero intero tra 0 e 1000.": "请输入 0 到 1000 之间的整数。",
  "Intero importo residuo": "全部剩余金额",
  "Intervallo di date non valido (al massimo un anno).": "日期范围无效（最长一年）。",
  "Inventario": "库存",
  "Invia invito": "发送邀请",
  "Invio a Stripe…": "正在提交至 Stripe…",
  "Invita persona": "邀请成员",
  "Inviti e ruoli del personale": "员工邀请与角色",
  "Invito inviato a {email}: riceverà un link per impostare la password.": "邀请已发送至 {email}，对方将收到设置密码的链接。",
  "Iscrizioni al Club": "会员加入",
  "Iscrizioni aperte nel negozio online": "在网上商店开放加入",
  "Iscrizioni e descrizione del Club": "会员加入与俱乐部简介",
  "Istruzioni (testo)": "说明（文本）",
  "Italiano": "Italiano",
  "IVA {rate}%": "增值税 {rate}%",
  "JPG, PNG o WEBP fino a 5 MB. Sfondo chiaro, formato quadrato (1200 × 1200).": "JPG、PNG 或 WEBP，最大 5 MB。建议浅色背景、正方形（1200 × 1200）。",
  "L'ordine verrà annullato e i prodotti tornano disponibili in magazzino.": "订单将被取消，商品将退回库存。",
  "La password deve avere almeno 10 caratteri.": "密码至少需要 10 个字符。",
  "Lascia vuoto per generarlo": "留空则自动生成",
  "Le celle vuote non cancellano i dati già presenti.": "空白单元格不会清除已有数据。",
  "Le password non coincidono.": "两次输入的密码不一致。",
  "Limite per cliente": "每位客户限用次数",
  "Lingua dell’interfaccia": "界面语言",
  "Lingua non disponibile.": "该语言不可用。",
  "Link scaduto o non valido. Richiedi un nuovo link dalla pagina di accesso.": "链接已过期或无效，请在登录页重新获取链接。",
  "Link tracciamento (https://)": "物流跟踪链接（https://）",
  "Lo sconto si applica ai prodotti; le fasce di spedizione usano l'importo scontato.": "折扣仅适用于商品；运费档位按折后金额计算。",
  "Locker e negozi convenzionati proposti al checkout": "结账时提供的自提柜和合作网点",
  "Lun–Sab 9:00–19:30": "周一至周六 9:00–19:30",
  "Magazzino": "库存",
  "Magazzino in ordine": "库存状况良好",
  "Mano (fatto a mano)": "手（手工制作）",
  "Marca": "品牌",
  "Marketing": "营销",
  "massimo 10 immagini": "最多 10 张图片",
  "massimo 4 punti di forza": "最多 4 个卖点",
  "Massimo per ordine": "每单上限",
  "Max pezzi per ordine": "每单最多件数",
  "Membri": "会员",
  "Membri del Club": "俱乐部会员",
  "Membro dal": "入会日期",
  "Membro del Club": "会员",
  "Metodo": "方式",
  "Metti «In evidenza» nella home": "设为首页精选",
  "Minimo": "最低消费",
  "minimo {amount}": "最低 {amount}",
  "Modalità di consegna": "配送方式",
  "Modello CSV": "CSV 模板",
  "Modifica": "编辑",
  "Modifica accesso": "编辑权限",
  "Modifica categoria": "编辑分类",
  "Modifica codice": "编辑优惠码",
  "Modifica manuale": "手动调整",
  "Modifica negozio": "编辑门店",
  "Modifica punto": "编辑自提点",
  "Modifica regola": "编辑规则",
  "Modificato": "已修改",
  "Modifiche": "修改内容",
  "Modifiche con effetto immediato su app e sito. Le regole attuali sono quelle approvate (docs/PROJECT_CONTEXT.md §6); la fascia oltre 10 kg è provvisoria.": "修改将立即在 App 和网站生效。当前规则为已批准版本（docs/PROJECT_CONTEXT.md §6）；10 kg 以上档位为临时设置。",
  "Modifiche non salvate": "未保存的修改",
  "Mostra": "显示",
  "Mostra in home": "首页展示",
  "Mostra in home ({n}/8 scelte; l'ordine segue il campo \"Ordine\")": "首页展示（已选 {n}/8；顺序按「排序」字段）",
  "Mostrato come “Varianti di …”": "显示为「…的规格」",
  "Motivo (visibile al cliente)": "原因（客户可见）",
  "Movimenti": "库存流水",
  "Movimenti · {name}": "库存流水 · {name}",
  "N. ordine": "订单号",
  "Nascondi": "隐藏",
  "Nascosta": "已隐藏",
  "Navigazione principale": "主导航",
  "Negozi": "门店",
  "Negozi e spedizioni": "门店与配送",
  "Negozio": "门店",
  "Negozio online": "网上商店",
  "Negozio preferito": "常去门店",
  "Nessun cliente trovato.": "未找到客户。",
  "Nessun cliente.": "暂无客户。",
  "Nessun codice riservato al Club. Creane uno in Marketing e spunta l’opzione per i membri del Club.": "还没有会员专享优惠码。请在「营销」中新建一个，并勾选会员专享选项。",
  "Nessun membro trovato.": "未找到会员。",
  "Nessun movimento.": "暂无库存流水。",
  "Nessun nuovo ordine.": "暂无新订单。",
  "Nessun ordine con questi filtri.": "没有符合筛选条件的订单。",
  "Nessun ordine da preparare": "暂无待备货订单",
  "Nessun ordine in attesa di ritiro o spedizione.": "暂无待自提或待发货的订单。",
  "Nessun ordine in corso.": "暂无进行中的订单。",
  "Nessun ordine nel periodo.": "该时段内没有订单。",
  "Nessun ordine.": "暂无订单。",
  "Nessun prodotto con {n} pezzi o meno.": "没有库存在 {n} 件及以下的商品。",
  "Nessun prodotto sotto scorta in questo negozio.": "该门店没有低库存商品。",
  "Nessun prodotto trovato.": "未找到商品。",
  "Nessun prodotto. Importa il catalogo da CSV o crea un prodotto.": "暂无商品。请通过 CSV 导入商品目录，或新建商品。",
  "nessun rimborso": "无退款",
  "Nessuna": "无",
  "Nessuna operazione con questi filtri.": "没有符合筛选条件的操作记录。",
  "Nessuna recensione nascosta.": "暂无已隐藏的评价。",
  "Nessuna recensione.": "暂无评价。",
  "nessuna vendita nel periodo": "该时段内无销售",
  "Nessuna vendita nel periodo.": "该时段内无销售。",
  "nessuno da preparare": "无待备货",
  "No": "否",
  "Nome": "名称",
  "Nome *": "名称 *",
  "Nome breve sotto la miniatura": "缩略图下方的短名称",
  "nome mancante": "缺少名称",
  "Nome variante": "规格名称",
  "Nome visualizzato": "显示名称",
  "Non attiva": "未启用",
  "Non hai i permessi per questa operazione.": "你没有执行此操作的权限。",
  "Non iscritto": "未加入",
  "Non pagato": "未付款",
  "Non pubblicati": "未上架",
  "Non pubblicato": "未上架",
  "Nota": "备注",
  "Note": "备注",
  "Note del cliente: {notes}": "客户备注：{notes}",
  "Note interne": "内部备注",
  "Numero ordini": "订单数",
  "Numero, email, nome, telefono": "订单号、邮箱、姓名、电话",
  "Nuova categoria": "新建分类",
  "Nuova password": "新密码",
  "Nuova regola": "新建规则",
  "Nuovi clienti": "新客户",
  "Nuovi clienti degli ultimi 7 giorni": "近 7 天新客户",
  "Nuovi membri (30 giorni)": "新会员（30 天）",
  "Nuovo codice sconto": "新建优惠码",
  "Nuovo negozio": "新建门店",
  "Nuovo prodotto": "新建商品",
  "Nuovo punto di ritiro": "新建自提点",
  "Obbligatori: {columns}.": "必填列：{columns}。",
  "Offerte Club attive": "生效中的会员优惠",
  "Offerte riservate ai membri": "会员专属优惠",
  "Oggi": "今天",
  "Oggi è {date} — insieme rendiamo la vita quotidiana ancora più bella.": "今天是 {date}，让我们一起把日常生活变得更美好。",
  "ogni immagine deve essere un link che inizia con https://": "每张图片都必须是以 https:// 开头的链接",
  "Ogni punto di forza può avere al massimo 40 caratteri.": "每个卖点最多 40 个字符。",
  "Orari": "营业时间",
  "Orari (mostrati ai clienti)": "营业时间（向客户展示）",
  "Ordine": "订单",
  "Ordine {number}": "订单 {number}",
  "Ordine annullato": "订单已取消",
  "Ordine annullato e {amount} rimborsati. I prodotti sono tornati in magazzino.": "订单已取消，已退款 {amount}。商品已退回库存。",
  "Ordine annullato. I prodotti sono tornati in magazzino.": "订单已取消。商品已退回库存。",
  "Ordine di visualizzazione": "显示顺序",
  "Ordine non rimborsabile.": "该订单无法退款。",
  "Ordine online": "线上订单",
  "Ordine selezionato": "已选订单",
  "Ordine##posizione": "排序",
  "Ordini": "订单",
  "Ordini da evadere": "待处理订单",
  "Ordini da evadere negli ultimi 7 giorni": "近 7 天待处理订单",
  "Ordini da preparare": "待备货订单",
  "Ordini degli ultimi 7 giorni": "近 7 天订单",
  "Ordini pagati": "已付款订单",
  "Ordini recenti": "最近订单",
  "Ordini, magazzino e catalogo dei negozi di Arezzo e Lucca, in un unico posto.": "阿雷佐和卢卡各门店的订单、库存与商品目录，一站式管理。",
  "P.IVA": "增值税号",
  "Padre": "上级",
  "Pagamento": "支付",
  "Pagamento non riuscito": "支付失败",
  "Pagamento ricevuto su ordine annullato: verificare il rimborso automatico su Stripe.": "已取消的订单收到付款：请在 Stripe 核实自动退款。",
  "Pagamento Stripe:": "Stripe 支付：",
  "Pagamento: {status}": "支付状态：{status}",
  "Pagato": "已付款",
  "pagato {age}": "{age}付款",
  "Pagina {n}": "第 {n} 页",
  "Panoramica": "概览",
  "Password": "密码",
  "Password aggiornata.": "密码已更新。",
  "Password dimenticata / primo accesso": "忘记密码 / 首次登录",
  "Per il prezzo al litro/kg indica sia la quantità sia l’unità (oppure lascia vuoti entrambi).": "如需显示每升/每千克单价，请同时填写数量和单位（或两者都留空）。",
  "Per il prezzo al litro/kg obbligatorio per legge (es. 500 ml)": "用于法定的每升/每千克单价标示（例如 500 ml）",
  "per ordine pagato": "每笔已付款订单",
  "per pezzi": "按件数",
  "Percentuale": "百分比",
  "Percentuale (%)": "百分比（%）",
  "Percentuale tra 1 e 100.": "百分比须在 1 到 100 之间。",
  "Periodo": "时段",
  "Periodo attuale": "本期",
  "Periodo precedente": "上期",
  "Periodo precedente ({day}): {value}": "上期（{day}）：{value}",
  "Permessi aggiornati.": "权限已更新。",
  "Persona": "成员",
  "Personale": "员工",
  "Personale negozio": "门店员工",
  "Personale negozio — ordini e magazzino del proprio negozio": "门店员工 — 本门店的订单和库存",
  "Personalizzato": "自定义",
  "Peso": "重量",
  "Peso (g)": "重量（g）",
  "Peso da (g, incluso)": "重量起（g，含）",
  "Peso fino a (g, incluso)": "重量止（g，含）",
  "Peso in grammi *": "重量（克）*",
  "peso mancante (necessario per il calcolo della spedizione)": "缺少重量（计算运费需要）",
  "Peso massimo": "最大重量",
  "Peso minimo": "最小重量",
  "Precedente": "上一页",
  "Preferenze personali e impostazioni del negozio.": "个人偏好与商店设置。",
  "Prepara ordini da spedire (domicilio / punti di ritiro)": "为待发货订单备货（送货上门 / 自提点）",
  "Preparati": "已备货",
  "Preparazione ordini": "订单备货",
  "Preparazione ordini per negozio": "按门店备货",
  "Prezzi per peso e importo": "按重量和金额计价",
  "Prezzo": "价格",
  "Prezzo (€)": "价格（€）",
  "Prezzo € (IVA inclusa) *": "价格 €（含增值税）*",
  "Prezzo barrato": "划线价",
  "Prezzo barrato €": "划线价 €",
  "prezzo barrato deve essere maggiore del prezzo": "划线价必须高于售价",
  "Prezzo e spedizione": "价格与运费",
  "prezzo non valido": "价格无效",
  "Prezzo non valido (usa 0 per gratuito).": "价格无效（免费请填 0）。",
  "Prezzo non valido.": "价格无效。",
  "Prezzo più basso degli ultimi 30 giorni (Omnibus)": "近 30 天最低价（Omnibus）",
  "Principale": "主图",
  "Priorità": "优先级",
  "Problema": "问题",
  "Prodotti": "商品",
  "Prodotti più venduti": "畅销商品",
  "Prodotti più venduti TOP 5": "畅销商品 TOP 5",
  "Prodotto": "商品",
  "Prodotto e {n} giacenze salvati.": "商品及 {n} 项库存已保存。",
  "Prodotto salvato.": "商品已保存。",
  "Programma fedeltà": "会员计划",
  "Pronti": "已备好",
  "Pronto": "已备好",
  "Provincia": "省份",
  "Provvisoria": "临时",
  "Pubblicati": "已上架",
  "Pubblicato": "已上架",
  "Pubblicato, visibile ai clienti": "已上架，客户可见",
  "Punti convenzionati per il ritiro": "合作自提点",
  "Punti di forza": "卖点",
  "Punti di ritiro": "自提点",
  "punto di forza {n} non valido (max 40 caratteri; icona tra: {icons})": "卖点 {n} 无效（最多 40 个字符；图标可选：{icons}）",
  "Punto di ritiro": "自提点",
  "Punto ritiro": "自提点",
  "Q.tà": "数量",
  "Quadrata, almeno 400×400 px. Senza foto il cerchio mostra l’icona del reparto.": "正方形，至少 400×400 像素。未上传时圆圈显示该大类的图标。",
  "Quantità": "数量",
  "Quantità confezione": "包装数量",
  "Quantità della confezione non valida.": "包装数量无效。",
  "Quantità non valida.": "数量无效。",
  "Questa variante *": "当前规格 *",
  "Questo mese": "本月",
  "Recensione": "评价",
  "Recensione di {name} di nuovo visibile.": "{name} 的评价已恢复显示。",
  "Recensione di {name} nascosta: non conta più nella media.": "{name} 的评价已隐藏，不再计入平均分。",
  "Recensione eliminata.": "评价已删除。",
  "Recensioni": "商品评价",
  "Registra spedizione": "登记发货",
  "Registrato": "已注册",
  "Registro attività": "操作日志",
  "Regole valutate per priorità crescente: vince la prima che corrisponde. Il ritiro in negozio è sempre gratuito.": "规则按优先级从小到大依次匹配，以第一条匹配的规则为准。门店自提始终免费。",
  "Rendi principale": "设为主图",
  "Responsabile": "经理",
  "Responsabile — catalogo, prezzi, promozioni, rimborsi, tutti i negozi": "经理 — 商品目录、价格、促销、退款，全部门店",
  "Rete": "物流网络",
  "Rete / corriere": "物流网络 / 快递公司",
  "Rete: {carrier}": "物流网络：{carrier}",
  "Riciclo (sostenibile)": "循环（可持续）",
  "Rifornisci": "补货",
  "Riga": "行",
  "Rimborsa": "退款",
  "Rimborsa {amount}": "退款 {amount}",
  "Rimborsa {amount} a {name}": "向 {name} 退款 {amount}",
  "Rimborsato": "已退款",
  "Rimborsato parzialmente": "部分退款",
  "Rimborsi": "退款",
  "Rimborsi con un clic tramite Stripe": "通过 Stripe 一键退款",
  "Rimborso di {amount} emesso. Il cliente lo vedrà in 5–10 giorni lavorativi.": "已发起 {amount} 退款，客户将在 5–10 个工作日内收到。",
  "Rimborso parziale": "部分退款",
  "Rimuovi": "移除",
  "Rimuovi dal Club": "移出会员",
  "Rimuovi punto {n}": "删除卖点 {n}",
  "rispetto a ieri": "较昨日",
  "rispetto al giorno prima": "较前一日",
  "Risultato verifica": "校验结果",
  "Ritiro": "自提",
  "Ritiro in negozio": "门店自提",
  "Ritiro in negozio abilitato": "已开通门店自提",
  "Ruolo": "角色",
  "Salva": "保存",
  "Salva giacenze": "保存库存",
  "Salva nota": "保存备注",
  "Salva password": "保存密码",
  "Salvataggio…": "保存中…",
  "Scarica modello Excel": "下载 Excel 模板",
  "Scatola (confezione)": "盒子（包装）",
  "Scegli file Excel o CSV": "选择 Excel 或 CSV 文件",
  "Scegli un ordine dalla lista: il più vecchio è in cima.": "从列表中选择订单：最早的订单在最上方。",
  "Scheda": "详情",
  "Scheda nel negozio online": "网上商店商品页",
  "Scintilla (pulito, brillante)": "闪光（洁净、亮泽）",
  "Sconto": "折扣",
  "Sconto {code}": "优惠 {code}",
  "Scontrino medio": "客单价",
  "Scorte aggiornate in tempo reale": "库存实时更新",
  "Scorte: {n}": "库存：{n}",
  "Scritte solo da clienti che hanno acquistato il prodotto. Nascondi quelle non appropriate: la media si aggiorna da sola.": "仅限购买过该商品的客户撰写。隐藏不当评价后，平均分会自动更新。",
  "Scrivi una breve descrizione del Club.": "请填写一段简短的会员俱乐部介绍。",
  "Scudo (resistente, sicuro)": "盾牌（耐用、安全）",
  "Se chiudi le iscrizioni, il Club sparisce dal negozio per chi non è membro. I membri attuali restano iscritti e possono uscire quando vogliono.": "关闭加入后，非会员将在商店中看不到会员俱乐部。现有会员仍保留会员资格，并可随时退出。",
  "Se l’indirizzo è registrato riceverai un link per impostare la password.": "如果该邮箱已注册，你将收到设置密码的链接。",
  "Segna come completato": "标记为已完成",
  "Segna come pronto": "标记为已备好",
  "Segna come spedito": "标记为已发货",
  "Segnala mancante": "报告缺货",
  "Segnalato: {name}. Un responsabile vedrà la nota nell'ordine {number}.": "已报告：{name}。经理将在订单 {number} 中看到该备注。",
  "Seleziona {n}": "选择 {n}",
  "Seleziona il negozio per il personale di negozio.": "请为门店员工选择所属门店。",
  "Seleziona tutti": "全选",
  "Senza commento": "无评论",
  "senza scadenza": "长期有效",
  "Serve per calcolare la spedizione": "用于计算运费",
  "Sezioni": "分区",
  "Sì": "是",
  "Simulatore": "运费模拟",
  "Sistema": "系统",
  "SKU {sku}": "SKU {sku}",
  "SKU / codice articolo *": "SKU / 商品编码 *",
  "SKU / EAN": "SKU / EAN",
  "SKU duplicato nel file": "文件中 SKU 重复",
  "SKU già esistente.": "SKU 已存在。",
  "SKU mancante o non valido (lettere, numeri, . _ -)": "SKU 缺失或无效（仅限字母、数字、. _ -）",
  "Slug": "Slug",
  "Slug già esistente.": "Slug 已存在。",
  "Soglia salvata.": "阈值已保存。",
  "Soglia scorte basse": "低库存阈值",
  "Soglia scorte basse (pezzi)": "低库存阈值（件）",
  "Sole (luce, estate)": "太阳（光照、夏季）",
  "Solo Club": "仅限会员",
  "Solo con consenso marketing": "仅含营销授权客户",
  "Solo per i membri del Casa & Te Club (mostrato nella pagina Club dell'app)": "仅限 CASA & TE Club 会员（显示在 App 的会员页面）",
  "Solo scorte basse (≤ {n})": "仅看低库存（≤ {n}）",
  "Spedisce": "可发货",
  "Spedisce ordini": "负责发货",
  "Spediti": "已发货",
  "Spedito": "已发货",
  "Spedizione": "配送",
  "Spedizione gratis": "免运费",
  "Spedizione gratuita": "免运费",
  "Spedizione:": "物流：",
  "Spedizioni e ritiro": "配送与自提",
  "Spesa massima": "最高消费",
  "Spesa minima": "最低消费",
  "Spesa minima prodotti (€)": "商品最低消费（€）",
  "Spunta ogni prodotto per completare. Se un prodotto manca, usa \"Segnala mancante\": un responsabile farà il rimborso parziale.": "逐一勾选商品以完成备货。如有商品缺货，请使用「报告缺货」：经理将进行部分退款。",
  "Stampa distinta": "打印拣货单",
  "Stato": "状态",
  "Stato ordini": "订单状态",
  "Stella (scelta, novità)": "星星（精选、新品）",
  "Stesso nome su tutti i prodotti del gruppo": "同组所有商品使用相同名称",
  "Stock totale": "总库存",
  "Stripe non raggiungibile o non configurato.": "无法连接 Stripe 或未配置。",
  "Successiva": "下一页",
  "sul periodo precedente": "较上期",
  "Tariffa di spedizione": "运费",
  "Tariffa oltre 10 kg (provvisoria)": "10 kg 以上运费（临时）",
  "Tariffa provvisoria": "临时运费",
  "Tariffe di spedizione": "运费设置",
  "Tariffe spedizione": "运费设置",
  "Tel.": "电话",
  "Telefono": "电话",
  "Testo {n}": "文字 {n}",
  "Tipo": "类型",
  "Titolo": "标题",
  "Togli da «In evidenza»": "取消首页精选",
  "Torna all'ordine": "返回订单",
  "Totale": "合计",
  "Totale ordini": "订单总数",
  "Tutte le azioni": "全部操作",
  "Tutte le categorie": "全部分类",
  "Tutte le consegne": "全部配送方式",
  "Tutti": "全部",
  "Tutti (esclusi non pagati)": "全部（不含未付款）",
  "Tutti gli ordini": "全部订单",
  "Tutti gli stati": "全部状态",
  "Tutti i clienti": "全部客户",
  "Tutti i negozi": "全部门店",
  "Tutti i prodotti": "全部商品",
  "Tutti i tipi": "全部类型",
  "Tutto evaso": "全部已处理",
  "Tutto pronto": "全部就绪",
  "Tutto salvato.": "已全部保存。",
  "Ultima modifica: {date}": "最后修改：{date}",
  "Ultimi 30 giorni": "近 30 天",
  "Ultimi 7 giorni": "近 7 天",
  "Ultimi 90 giorni": "近 90 天",
  "Ultimo rimborso:": "最近一次退款：",
  "Un pezzo in meno di {name}": "{name} 减少一件",
  "Un pezzo in più di {name}": "{name} 增加一件",
  "Un prodotto è «sotto scorta» quando in un negozio ne restano al massimo questi pezzi. Usata in Panoramica (Avviso scorte) e in Gestione inventario (Solo scorte basse).": "当某门店的剩余件数不超过此数值时，商品即视为「低库存」。用于概览（库存预警）和库存管理（仅看低库存）。",
  "Unità": "单位",
  "Usato dal filtro Colore": "用于颜色筛选",
  "Utente": "用户",
  "Utente già esistente.": "用户已存在。",
  "Utilizzi": "使用次数",
  "Utilizzi dei codici Club": "会员优惠码使用次数",
  "Utilizzi massimi": "最多使用次数",
  "Utilizzi massimi totali": "总使用次数上限",
  "Utilizzi per cliente": "每位客户使用次数",
  "Vai al contenuto": "跳到主要内容",
  "Vai alla preparazione": "去备货",
  "Vale solo per te: ogni membro del personale sceglie la propria lingua. Il negozio online resta in italiano.": "仅对你生效：每位员工可自选语言。网上商店仍为意大利语。",
  "Validità": "有效期",
  "Valido dal": "生效日期",
  "Valido fino al": "截止日期",
  "Valore": "数值",
  "Valore da (€, incluso)": "金额起（€，含）",
  "Valore fino a (€, incluso)": "金额止（€，含）",
  "Valore prodotti": "商品金额",
  "Valore prodotti (€)": "商品金额（€）",
  "Valori non validi: controlla i campi.": "数值无效，请检查各字段。",
  "Valutazione": "评分",
  "Vanno bene anche i CSV con le stesse intestazioni.": "也支持表头相同的 CSV 文件。",
  "Variante": "规格",
  "variante {label}": "规格 {label}",
  "Varianti": "规格",
  "Variazione": "变动",
  "Vendite degli ultimi 7 giorni": "近 7 天销售额",
  "Vendite di oggi": "今日销售额",
  "Venduti {n}": "已售 {n}",
  "Verifica {i}/{n}…": "校验中 {i}/{n}…",
  "Visibile": "可见",
  "Visibile ai clienti": "客户可见",
  "Visibile ai membri del Club nella pagina delle offerte": "会员可在优惠页面查看",
  "Visibile al cliente": "客户可见",
  "Visibilità": "可见性",
  "Visualizza": "查看",
  "Visualizza tutti gli ordini": "查看全部订单",
  "Visualizza tutto": "查看全部",
  "Vuoto = nessun limite": "留空 = 不限",
  "I primi {n} sono quelli visibili in home.": "前 {n} 个会显示在首页。",
  "In cima": "置顶",
  "In offerta": "特价商品",
  "Nessun prodotto in evidenza: aggiungi la stella ai prodotti in Gestione prodotti.": "还没有精选商品：请在商品管理中给商品加星标。",
  "Nessun prodotto in offerta: imposta un prezzo barrato nella scheda del prodotto.": "还没有特价商品：请在商品详情中设置划线原价。",
  "Ordine salvato.": "顺序已保存。",
  "Prodotti con la stella in Gestione prodotti. Trascina le righe o usa le frecce, poi salva.": "在商品管理中加了星标的商品。拖动行或使用箭头调整，然后保存。",
  "Prodotti con un prezzo barrato più alto del prezzo. Trascina le righe o usa le frecce, poi salva.": "划线原价高于售价的商品。拖动行或使用箭头调整，然后保存。",
  "Salva ordine": "保存顺序",
  "Scegli l'ordine dei prodotti nelle righe «In evidenza» e «In offerta» della home del negozio online.": "设置网店首页“In evidenza”和“In offerta”两栏中商品的显示顺序。",
  "Sposta giù": "下移",
  "Sposta su": "上移",
  "Torna all’ordine alfabetico": "恢复按字母排序",
  "Torna all’ordine per sconto": "恢复按折扣排序",
  "Vetrina home": "首页橱窗",
  "in home": "首页显示",
  "Bozza": "草稿",
  "Programmato": "已排期",
  "Scaduto": "已过期",
  "Visibile nel negozio": "商店可见",
  "Volantino": "宣传单",
  "Il volantino del mese nell’app e nel negozio online: carica le pagine come immagini e/o il PDF da scaricare. I clienti vedono solo quelli pubblicati e nel periodo di validità.": "App 和网店里的每月宣传单：上传每页图片和/或可下载的 PDF。顾客只能看到已发布且在有效期内的宣传单。",
  "+ Nuovo volantino": "+ 新建宣传单",
  "Nessun volantino. Creane uno con «+ Nuovo volantino».": "还没有宣传单。点“+ 新建宣传单”创建。",
  "Contenuto": "内容",
  "{n} pagine": "{n} 页",
  "Apri PDF": "打开 PDF",
  "Modifica volantino": "编辑宣传单",
  "Nuovo volantino": "新建宣传单",
  "es. Volantino di ottobre": "例如：十月宣传单",
  "La fine è prima dell’inizio.": "截止日期早于生效日期。",
  "Pubblicato (visibile ai clienti nel periodo di validità)": "发布（有效期内对顾客可见）",
  "Pagine (immagini, nell’ordine di lettura)": "页面（图片，按阅读顺序）",
  "Aggiungi pagine": "添加页面",
  "JPG, PNG o WEBP, in verticale (es. 1200×1700 px). Puoi selezionare più file insieme: vengono ordinati per nome.": "JPG、PNG 或 WEBP，竖版（例如 1200×1700 像素）。可一次选择多个文件，按文件名排序。",
  "PDF da scaricare (facoltativo)": "可下载的 PDF（可选）",
  "Nessun PDF": "没有 PDF",
  "Sostituisci PDF": "替换 PDF",
  "Carica PDF": "上传 PDF",
  "Aggiungi almeno le pagine o il PDF.": "至少添加页面或 PDF。",
  "Il file deve essere un PDF.": "文件必须是 PDF。",
  "PDF troppo grande (max 25 MB).": "PDF 太大（最大 25 MB）。",
  "Immagine troppo grande (max 8 MB).": "图片太大（最大 8 MB）。",
  "Al massimo 40 pagine.": "最多 40 页。",
  "Eliminare il volantino \"{name}\"?": "删除宣传单“{name}”？",
  "— Seleziona —": "— 请选择 —",
  "+ Nuova azienda": "+ 新建公司",
  "Alcuni negozi attivi non sono collegati a un’azienda: collegali in Negozi.": "部分营业中的门店还没有关联公司：请在“门店”中关联。",
  "Alcuni negozi attivi non sono collegati a un’azienda: i loro ordini usano i dati del gestore.": "部分营业中的门店还没有关联公司：它们的订单将使用平台运营方的信息。",
  "Azienda": "公司",
  "Azienda (venditore degli ordini di questo negozio)": "公司（本门店订单的卖家）",
  "Aziende": "公司",
  "CAP non valido (5 cifre).": "邮编无效（5 位数字）。",
  "Capitale sociale non valido.": "注册资本无效。",
  "Capitale sociale versato (€)": "实缴注册资本（€）",
  "Codice fiscale": "税号（C.F.）",
  "Codice fiscale non valido.": "税号无效。",
  "Contatti": "联系方式",
  "Controlla gli indirizzi email.": "请检查邮箱地址。",
  "Copia i dati dalla visura camerale. Le modifiche valgono per i nuovi ordini; gli ordini già fatti conservano i dati del venditore di allora.": "请照公司登记证明（visura）填写。修改只对新订单生效，已有订单保留下单时的卖家信息。",
  "Da collegare": "待关联",
  "Dati legali mostrati nelle condizioni di vendita, nella privacy e negli ordini. Il gestore è chi pubblica l’app; il venditore di un ordine è l’azienda del negozio che lo prepara.": "用于销售条款、隐私政策和订单的法定信息。运营方是发布 App 的公司；订单的卖家是负责备货的门店所属公司。",
  "Eliminare l’azienda \"{name}\"?": "删除公司“{name}”？",
  "Email assistenza clienti": "客服邮箱",
  "Email privacy": "隐私联系邮箱",
  "Esiste già un gestore della piattaforma.": "已经有一个平台运营方。",
  "Gestore": "运营方",
  "gestore": "运营方",
  "Gestore della piattaforma (chi pubblica l’app e il sito)": "平台运营方（发布 App 和网站的公司）",
  "Indica quale azienda gestisce la piattaforma (gestore).": "请指定哪家公司是平台运营方。",
  "Le aziende si gestiscono in Negozi → Aziende": "公司在“门店 → 公司”中管理",
  "Lo scontrino o la fattura vanno emessi da questa azienda.": "小票或发票须由该公司开具。",
  "Modifica azienda": "编辑公司",
  "Nessuna azienda. Aggiungi il gestore e le aziende dei negozi.": "还没有公司。请添加平台运营方和各门店的公司。",
  "Numero REA": "REA 编号",
  "Nuova azienda": "新建公司",
  "Partita IVA": "增值税号（P.IVA）",
  "Partita IVA non valida (11 cifre).": "增值税号无效（11 位数字）。",
  "Per le richieste sui dati personali; se vuota si usa l’email assistenza": "用于个人数据相关请求；留空则使用客服邮箱",
  "Prima scollega i negozi da questa azienda.": "请先解除门店与该公司的关联。",
  "Provincia non valida (2 lettere, es. LU).": "省份无效（2 个字母，例如 LU）。",
  "Questa partita IVA è già registrata.": "该增值税号已登记。",
  "Ragione sociale": "公司名称",
  "Ragione sociale, indirizzo e città sono obbligatori.": "公司名称、地址和城市为必填项。",
  "Se uguale alla partita IVA puoi lasciarlo vuoto": "与增值税号相同时可留空",
  "Sede legale (via e numero)": "注册地址（街道和门牌号）",
  "Un negozio attivo deve essere collegato all’azienda che vende i suoi ordini.": "营业中的门店必须关联负责其订单销售的公司。",
  "Venditore": "卖家",
  "Annulla registrazione": "撤销登记",
  "Batti l’ordine sul registratore di cassa del negozio, poi segnalo qui. Fino ad allora la merce resta esclusa dalla disponibilità online.": "请先在门店收银机上录入这笔订单，再在这里标记。在此之前，这些商品不计入网店可售库存。",
  "Cassa": "收银",
  "Cassa: tutti": "收银：全部",
  "Da registrare in cassa": "待收银登记",
  "Ordine registrato in cassa": "订单已收银登记",
  "Prezzo, promozioni e giacenze arrivano dal gestionale (codice {code}): le modifiche a prezzo qui vengono sovrascritte alla prossima sincronizzazione. Nome, descrizione, categoria e foto restano quelli impostati qui.": "价格、促销和库存来自管理软件（编码 {code}）：在这里改的价格会在下次同步时被覆盖。名称、描述、分类和照片以这里的设置为准。",
  "Registrati in cassa": "已收银登记",
  "Registrato in cassa": "已收银登记",
  "Registrato in cassa il {date}. Il gestionale scalerà la merce alla prossima sincronizzazione.": "已于 {date} 收银登记。管理软件会在下次同步时扣减库存。",
  "Registrazione in cassa annullata": "已撤销收银登记",
  "Segna come registrato in cassa": "标记为已收银登记",
  "Peso in grammi": "重量（克）",
  "Peso in grammi non valido.": "重量无效。",
  "Senza peso": "无重量",
  "Senza peso il prodotto si può solo ritirare in negozio": "没有重量的商品只能到店自提",
  "Resi e assistenza": "退货与售后",
  "Le richieste dei clienti dalla pagina dell’ordine. Il responsabile approva e rimborsa; il negozio registra la consegna degli articoli.": "顾客在订单页提交的申请。经理负责审批和退款；门店登记顾客交回的商品。",
  "Da gestire": "待处理",
  "Da valutare": "待审核",
  "Attesi in negozio": "等待到店",
  "Da rimborsare o cambiare": "待退款或换货",
  "Chiusi": "已结束",
  "Codice reso (RESO-…)": "退货码（RESO-…）",
  "Cerca per codice reso": "按退货码搜索",
  "Nessuna richiesta.": "暂无申请。",
  "Reso": "退货",
  "Motivo": "原因",
  "Richiesta": "诉求",
  "Cambio": "换货",
  "Rimborso": "退款",
  "In valutazione": "审核中",
  "Approvato": "已批准",
  "Non accettato": "已拒绝",
  "Articoli ricevuti in negozio": "门店已收货",
  "Cambio completato": "换货完成",
  "Ho cambiato idea": "不想要了",
  "Difettoso o danneggiato": "有缺陷或损坏",
  "Articolo sbagliato": "发错货",
  "Articolo mancante": "缺件",
  "Sul metodo di pagamento": "原路退回",
  "Buono CASA & TE": "CASA & TE 代金券",
  "Cambio con lo stesso prodotto": "换同款商品",
  "Foto del cliente": "顾客照片",
  "Nota della decisione": "审批备注",
  "Buono emesso": "已发代金券",
  "Rimborsato sulla carta": "已退回银行卡",
  "Nota per il cliente": "给顾客的备注",
  "Obbligatoria se rifiuti: il cliente la riceve via email.": "拒绝时必填：顾客会通过邮件收到。",
  "{n} approvato: il cliente porterà gli articoli in negozio.": "{n} 已批准：顾客会把商品送到门店。",
  "Approva": "批准",
  "{n} rifiutato.": "{n} 已拒绝。",
  "Rifiuta": "拒绝",
  "In attesa dell’approvazione di un responsabile.": "等待经理审批。",
  "Controlla gli articoli quando il cliente li porta in negozio, poi registra la consegna.": "顾客把商品送到门店时检查商品，然后登记收货。",
  "Articoli del reso {n} ricevuti.": "退货 {n} 的商品已收到。",
  "Cambio {n} completato.": "换货 {n} 已完成。",
  "Prodotto sostitutivo consegnato": "已交付换货商品",
  "Importo da rimborsare (€)": "退款金额（€）",
  "Al massimo {max}: il valore pagato per gli articoli resi.": "最多 {max}：即退货商品的实付金额。",
  "Rimborso di {amount} emesso sulla carta.": "已原路退款 {amount}。",
  "Rimborsa sulla carta": "原路退款",
  "Buono di {amount} emesso: il cliente riceve il codice via email.": "已发放 {amount} 代金券：顾客会通过邮件收到券码。",
  "Emetti buono": "发放代金券",
  "Il cliente ha scelto: {m}.": "顾客选择：{m}。",
  "Il rimborso lo emette un responsabile.": "退款由经理操作。",
  "Operazione non possibile nello stato attuale del reso.": "当前退货状态下无法执行此操作。",
  "Reso non trovato.": "找不到该退货。",
  "Scrivi il motivo del rifiuto.": "请填写拒绝原因。",
  "Nota per i clienti (facoltativa)": "给顾客的说明（可选）",
  "Es. per chi valgono le offerte. Max 300 caratteri.": "例如：这些优惠适用于谁。最多 300 个字符。",
  "Titolo pagina": "页面标题",
  "Titolo della pagina {n}": "第 {n} 页的标题",
};
export default dict;
